import { ActivatedRouteSnapshot, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { SessionStorageService } from '@lentau/ui-kit/core/services/storage/sessionstorage.service';
import {
  SELECTION_GROUP_ID,
  SELECTION_ID,
} from '@lentau/selections-redesign/listing/application/selections-filters-storage-key';

/**
 * При переходе на PDP сохраняет состояние листинга для возврата назад.
 * При остальных переходах за пределы раздела сбрасывает фильтры.
 *
 * @param rootRegExp - регулярное выражение для определения корневого URL раздела
 */
export const resetSelectionsSessionStorageByUrlFactory = (rootRegExp: RegExp) => {
  const regExp = rootRegExp;
  return (
    _component: unknown,
    _activate: ActivatedRouteSnapshot,
    _routerState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): MaybeAsync<GuardResult> => {
    const sessionStorage: SessionStorageService = inject(SessionStorageService);

    const shouldResetFilters: boolean = !regExp.test(nextState.url);

    if (shouldResetFilters) {
      sessionStorage.removeItemByKey(SELECTION_GROUP_ID);
      sessionStorage.removeItemByKey(SELECTION_ID);
    }
    return true;
  };
};
